module.exports = __webpack_public_path__ + "img/hippolyte-auguste-marinoni.366deadd.png";